import type { AuthenticationAccessRight } from "src/authentication/objects/AuthenticationToken";

export default class OfferAccessRight {
  public static VIEW_OFFERS: AuthenticationAccessRight = ({
    menuDisplayLevel,
  }) => menuDisplayLevel <= 2 || menuDisplayLevel >= 4;
}
